module.exports = __webpack_public_path__ + "static/img/logo-black.63b89bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-black.png
// module id = wsGn
// module chunks = 11